module.exports = __webpack_public_path__ + "img/about_img.f3e8d5d6.jpg";